import { useState } from 'react';
import { supabase } from '../lib/supabase';

// Pre-launch email capture for the landing page (MEA-199). Writes to the
// insert-only `waitlist` table; duplicate emails are a silent no-op so a second
// submit still reads as success (and never reveals the address is already on it).
export default function WaitlistForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | submitting | done
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const clean = email.trim().toLowerCase();
    if (!clean) return;
    setStatus('submitting');
    const { error: insertError } = await supabase
      .from('waitlist')
      .upsert({ email: clean, source: 'landing' }, { onConflict: 'email', ignoreDuplicates: true });
    if (insertError) {
      setError("Couldn't add you just now. Try again.");
      setStatus('idle');
      return;
    }
    setStatus('done');
  };

  if (status === 'done') {
    return (
      <div className="rounded-panel bg-surface border border-hairline p-6 text-center">
        <h3 className="font-body text-lg font-semibold text-ink mb-2">You&apos;re on the list</h3>
        <p className="font-body text-sm text-ink-secondary leading-relaxed">
          We&apos;ll email <span className="font-medium text-ink">{email.trim()}</span> when Suppertide is ready for you.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="rounded-panel bg-surface border border-hairline p-6">
      <label htmlFor="waitlist-email" className="block font-body text-sm font-medium text-ink-secondary mb-1.5">
        Email address
      </label>
      <input
        id="waitlist-email"
        type="email"
        required
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        className="w-full px-4 py-3 rounded-btn border border-border bg-surface font-body text-ink placeholder:text-ink-muted focus:outline-none focus:ring-2 focus:ring-primary/60 focus:border-primary transition-colors"
      />
      {error && <p className="mt-3 font-body text-sm text-danger">{error}</p>}
      <button
        type="submit"
        disabled={status === 'submitting'}
        className="w-full mt-4 py-3 rounded-btn bg-primary text-ink-inverse font-body font-medium hover:bg-primary-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {status === 'submitting' ? 'Joining…' : 'Join the waitlist'}
      </button>
    </form>
  );
}
